"use client";
import { useOldTrips, useTripsAndDepartures } from "@myaccount/_client/hooks";
import React from "react";
import { OldTripCard, TripCard } from "../trip-card";
import { TripList } from "../trip-list";

export type PastTripsProps = {
    limit?: number;
    title?: string;
};

export const PastTrips: React.FC<PastTripsProps> = ({ limit, title }) => {
    const { pastTripsAndDepartures } = useTripsAndDepartures();

    const confirmedOldTrips = useOldTrips();
    const pastTripsAndDeparturesList = pastTripsAndDepartures.filter(
        (
            tripAndDeparture,
        ): tripAndDeparture is typeof tripAndDeparture &
            Required<Pick<typeof tripAndDeparture, "trip">> =>
            !!tripAndDeparture.trip,
    );

    if (
        pastTripsAndDeparturesList.length === 0 &&
        confirmedOldTrips.length === 0
    ) {
        return null;
    }

    const pastAndOldTrips = [
        ...pastTripsAndDeparturesList,
        ...confirmedOldTrips,
    ];

    return (
        <TripList title={title}>
            {pastAndOldTrips.slice(0, limit).map((trip) => {
                if ("departure" in trip) {
                    return (
                        <TripCard
                            key={trip.trip._id}
                            isPastTrip={true}
                            {...trip}
                        />
                    );
                }
                return <OldTripCard key={trip._id} trip={trip} />;
            })}
        </TripList>
    );
};
